import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTimes, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import ProcessButton from '../buttons/ProcessButton';

const text1Str = "Your verification was not successful.\nPlease try again.";
const text2Str = "You will be asked to provide the following";

export default function StepFive(props) {
  
    let textColor = props.whiteColor, yellowColor = props.yellowColor, redColor = props.redColor, 
    greenColor = props.greenColor;
  
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FontAwesomeIcon icon={faUserTimes} style={{ color: redColor, fontSize: 30, marginTop: 30 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        margin: 30 }}>
            <div style={{ fontSize: 18, fontFamily: 'OpenSans-SemiBold', color: redColor }}>
                ID VERIFICATION NOT SUCCESSFUL
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: redColor, lineHeight: 1.2,
            whiteSpace: 'break-spaces', textAlign: 'center' }}>
                {text1Str}
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: textColor, lineHeight: 1.2,
            textAlign: 'center', marginTop: 30 }}>
                {text2Str}
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: textColor, marginTop: 12 }}>
                <ul>
                <li>Govt. ID with Photo - Front</li>
                <li>Govt. ID with Photo - Back</li>
                <li>A Video Selfie</li>
                </ul>
            </div>
            <div style={{ fontSize: 12, fontFamily: 'OpenSans-Regular', color: greenColor, lineHeight: 1.2,
            textAlign: 'center', marginTop: 20 }}>
                Need Support?
            </div>
            <div style={{ fontSize: 16, fontFamily: 'OpenSans-Regular', color: greenColor, lineHeight: 1.2,
            textAlign: 'center', marginTop: 8 }}>
                help@hitmovie.in
            </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 60 }}>
            <ProcessButton text="Start Verification" bgColor={yellowColor} 
            onClick={()=>{props.startVerification()}} />
            <div onClick={()=> window.open("https://docs.hit.movie/identity-verification", "_blank")} style={{ position: 'absolute', marginLeft: 220, marginTop: 10, cursor: 'pointer' }}>
                <FontAwesomeIcon icon={faQuestionCircle} style={{ color: yellowColor, fontSize: 20 }} />
            </div>
        </div>
      </div>
    );
}